import { FontFamily, FontWeight, Sizes } from './text.types';
import { ColorPalette } from '../colors';

export const fontFamily: Record<FontFamily, string> = {
    roboto: 'font-roboto',
    poppins: 'font-poppins',
};

export const fontWeight: Record<FontWeight, string> = {
    normal: 'font-normal', //400
    medium: 'font-medium', //500
    semibold: 'font-semibold', //600
    bold: 'font-bold', //700
    bolder: 'font-extrabold', //800
};

export const fontColor: Record<ColorPalette, string> = {
    'primary-50': 'text-primary-50',
    'primary-100': 'text-primary-100',
    'primary-200': 'text-primary-200',
    'primary-300': 'text-primary-300',
    'primary-400': 'text-primary-400',
    'primary-500': 'text-primary-500',
    'primary-600': 'text-primary-600',
    'primary-700': 'text-primary-700',
    'primary-800': 'text-primary-800',
    'primary-900': 'text-primary-900',
    'secondary-50': 'text-secondary-50',
    'secondary-100': 'text-secondary-100',
    'secondary-200': 'text-secondary-200',
    'secondary-300': 'text-secondary-300',
    'secondary-400': 'text-secondary-400',
    'secondary-500': 'text-secondary-500',
    'secondary-600': 'text-secondary-600',
    'secondary-700': 'text-secondary-700',
    'secondary-800': 'text-secondary-800',
    'secondary-900': 'text-secondary-900',
    'variant-50': 'text-variant-50',
    'variant-100': 'text-variant-100',
    'variant-200': 'text-variant-200',
    'variant-300': 'text-variant-300',
    'variant-400': 'text-variant-400',
    'variant-500': 'text-variant-500',
    'variant-600': 'text-variant-600',
    'variant-700': 'text-variant-700',
    'variant-800': 'text-variant-800',
    'variant-900': 'text-variant-900',
    'gray-50': 'text-gray-50',
    'gray-100': 'text-gray-100',
    'gray-200': 'text-gray-200',
    'gray-300': 'text-gray-300',
    'gray-400': 'text-gray-400',
    'gray-500': 'text-gray-500',
    'gray-600': 'text-gray-600',
    'gray-700': 'text-gray-700',
    'gray-800': 'text-gray-800',
    'gray-900': 'text-gray-900',
    white: 'text-white',
    black: 'text-black',
    'success-50': 'text-success-50',
    'success-100': 'text-success-100',
    'success-200': 'text-success-200',
    'warning-50': 'text-warning-50',
    'warning-100': 'text-warning-100',
    'warning-200': 'text-warning-200',
    'error-50': 'text-error-50',
    'error-100': 'text-error-100',
    'error-200': 'text-error-200',
    'surface-high': 'text-surface-high',
    'surface-medium': 'text-surface-medium',
    'surface-disabled': 'text-surface-disabled',
    'default-state': 'text-default-state',
    'delayed-state': 'text-delayed-state',
    'successful-state': 'text-successful-state',
};

export const fontSize: Record<Sizes, string> = {
    10: 'text-[10px]',
    12: 'text-[12px]',
    14: 'text-[14px]',
    16: 'text-[16px]',
    18: 'text-[18px]',
    20: 'text-[20px]',
    22: 'text-[22px]',
    24: 'text-[24px]',
    26: 'text-[26px]',
    28: 'text-[28px]',
    30: 'text-[30px]',
    32: 'text-[32px]',
    34: 'text-[34px]',
    36: 'text-[36px]',
    38: 'text-[38px]',
    40: 'text-[40px]',
};

export const fontLineHeight: Record<Sizes, string> = {
    10: 'leading-[10px]',
    12: 'leading-[12px]',
    14: 'leading-[14px]',
    16: 'leading-[16px]',
    18: 'leading-[18px]',
    20: 'leading-[20px]',
    22: 'leading-[22px]',
    24: 'leading-[24px]',
    26: 'leading-[26px]',
    28: 'leading-[28px]',
    30: 'leading-[30px]',
    32: 'leading-[32px]',
    34: 'leading-[34px]',
    36: 'leading-[36px]',
    38: 'leading-[38px]',
    40: 'leading-[40px]',
};
